/**
 * Contains all the styled-components for the main MobileWizard layout.
 * This separates the visual structure from the component's logic.
 */

import styled from 'styled-components';

export const WizardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%; 
  background-color: #e9ecef;
  font-family: 'Poppins', sans-serif;
`;

export const WizardBody = styled.div`
  position: relative; /* For the opener buttons */
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;  
`;

export const Panel = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  transition: all 0.35s ease-in-out;
  overflow: hidden;
`;

export const LeftPanelContainer = styled(Panel)`
  flex: ${({ isOpen }) => (isOpen ? '1 1 50%' : '0 0 0')};
  border: ${({ isOpen }) => (isOpen ? '1px solid #dee2e6' : 'none')};
  min-width: 0; /* Important for allowing it to shrink */
  margin: 0 4px;
`;

export const MainContent = styled.main`
  flex: 1 1 600px;
  min-width: 400px; /* Prevents it from getting too squished */

  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
`;

export const RightPanelContainer = styled(Panel)`
  flex: ${({ isOpen }) => (isOpen ? '0 0 450px' : '0 0 0')};
  border: ${({ isOpen }) => (isOpen ? '1px solid #dee2e6' : 'none')};
  min-width: 0; /* Important for allowing it to shrink */
  margin: 0 4px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.2rem;
  color: #666;
`;

export const PanelOpener = styled.button`
  position: absolute;
  top: 60px;
  width: 40px;
  height: 40px;
  background-color: #7A9F3F;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  left: ${({ side }) => (side === 'left' ? '30px' : 'auto')};
  right: ${({ side }) => (side === 'right' ? '30px' : 'auto')};
`;